import React from "react";
import { Accordion, Badge } from "react-bootstrap";
import { FaAws } from "react-icons/fa";

const AccountAccordion = ({
  accounts,
  errorAccounts,
  loadingAccounts,
  pagination,
  onAccordionClick,
  renderBody,
  activeKey,
  onSelect,
}) => (
  <Accordion activeKey={activeKey} onSelect={onSelect} alwaysOpen>
    {accounts.map((account, accIdx) => {
      const hasError = errorAccounts.includes(accIdx);
      const isLoading = loadingAccounts.includes(accIdx);
      const { page, perPage } = pagination[accIdx] || { page: 1, perPage: 5 };

      return (
        <Accordion.Item
          eventKey={accIdx.toString()}
          key={account.id}
          className={`mb-2 border-0 shadow-sm${
            hasError ? " aws-accordion-error" : ""
          }`}
          onClick={() => onAccordionClick(accIdx)}
          style={
            hasError
              ? {
                  border: "2px solid #dc3545",
                  boxShadow: "0 0 0 0.2rem rgba(220,53,69,.25)",
                  background: "#fff5f5",
                  position: "relative",
                }
              : {}
          }
        >
          <Accordion.Header>
            <div className="d-flex align-items-center">
              <FaAws
                style={{
                  marginRight: "10px",
                  fontSize: "22px",
                  color: "#ff9900",
                }}
              />
              <div>
                <div className="fw-bold">
                  {account.name}
                  {account.env.map((envItem, idx) => (
                    <Badge bg="secondary" key={idx} className="ms-1">
                      {envItem}
                    </Badge>
                  ))}
                </div>
                <small className="text-muted">Account ID: {account.id}</small>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body
            className={`bg-light border rounded${
              hasError ? " border-danger" : ""
            }`}
          >
            {renderBody({
              account,
              accIdx,
              hasError,
              isLoading,
              page,
              perPage,
            })}
          </Accordion.Body>
        </Accordion.Item>
      );
    })}
  </Accordion>
);

export default AccountAccordion;
